<template>
    <div class="form__group">
        <label for="event" class="form__label">Deal Type</label>
        <multiselect
            :options="options"
            :placeholder="placeholder"
            :allow-empty="allowEmpty"
            label="label"
            track-by="id"
            :loading="loading"
            v-model="selected"
            @change="updateValue"
            :class="{ 'form__control': true, 'form__control--invalid': errors.first(this.name) }">
        >
            <span slot="noOptions">Type a name to search users...</span>
        </multiselect>
    </div>
</template>

<script>
    import AjaxSelect from '../../Form/Control/AjaxSelect';
    import { ActivityTypesArray } from '../../../resources/ActivityTypes';

    export default {
        name: 'DealTypeDropdown',
        mixins: [AjaxSelect],
        props: {
            value: {
                type: String|Number,
                default: ''
            },
            events: {
                type: Array,
                default: () => []
            }
        },
        created() {
          this.options.find(option => {
              if (option.value === this.value) {
                  this.selected = option;
              }
          });
        },
        data: () => {
             console.log("Activity Types: ", ActivityTypesArray);

            return {
                options: ActivityTypesArray,
            }
        },
        methods: {
            updateValue(event) {
                console.log("Got value", event);
                this.$emit('input', event);
            },
            eventName(event) {
                return event.eventName;
            },
        }
    }
</script>

<style scoped lang="scss">

</style>
